export const LOGIN_REQUEST="lOGIN_REQUEST";
export const LOGIN_SUCCESS="lOGIN_SUCCESS";
export const LOGIN_FAILURE="lOGIN_FAILURE";

export const GET_CART_DATA = "GET_CART_DATA";

export const SIGNUP_REQUEST="SIGNUP_REQUEST";
export const SIGNUP_SUCCESS="SIGNUP_SUCCESS";
export const SIGNUP_FAILURE="SIGNUP_FAILURE";

export const CART_REQUEST="CART_REQUEST";
export const CART_SUCCESS="CART_SUCCESS";
export const CART_FAILURE="CART_FAILURE";

